var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/timeline.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"content\" style=\"height: 100%\">\r\n\t<form class=\"form-view grid row\">\r\n\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t<label class=\"form-field\">\r\n\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"StartDate"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t<div class=\"form-input required-field date-picker\" data-replace=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"customData")),"startDate"), env.opts.autoescape);
output += "\" data-type=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"settings")),"UseDateTime")?"DateTime":"Date"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t<input type=\"text\" name=\"StartDate\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"customData")),"startDate"), env.opts.autoescape);
output += "\" class=\"editable-text no-field date\">\r\n\t\t\t\t</div>\r\n\t\t\t</label>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t<label class=\"form-field\">\r\n\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"EndDate"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t<div class=\"form-input required-field date-picker\" data-replace=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"customData")),"endDate"), env.opts.autoescape);
output += "\" data-type=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"settings")),"UseDateTime")?"DateTime":"Date"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t<input type=\"text\" name=\"EndDate\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"customData")),"endDate"), env.opts.autoescape);
output += "\" class=\"editable-text no-field date\">\r\n\t\t\t\t</div>\r\n\t\t\t</label>\r\n\t\t</div>\r\n\t</form>\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col col-12\">\r\n\t\t\t<div class=\"chart\"></div>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/timeline.html"] , dependencies)